import Vue from 'vue';
import App from './App.vue';
import './assets/styles/styles.scss';

import UIkit from './js/uikit-core';
window.UIkit = UIkit;

import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);
Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue(); // Global event bus

new Vue({
  render: h => h(App)
}).$mount('#app');
